export default __webpack_public_path__ + "static/media/ic_shopping_cart_white_24px.be796e39.svg";